module.exports = __webpack_public_path__ + "static/img/satanizador-2.a111457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/satanizador-2.jpg
// module id = 7Kzj
// module chunks = 1